<template>
    <div>
        <BasePopup closeType="stayOnPage" width="700" @clickToClose="clickToClose" :displayGrid="'display:grid;'">
            <header>
            <font-awesome-icon icon="fa-solid  fa-bullhorn" style="color: #28bc6d;"/>
            <span v-if="route.name == 'campaignTrackerEdit'" class="ms-2 align-middle">Editar Rastreador</span>
            <span v-else class="ms-2 align-middle">Novo Rastreador</span>
        </header>
        <form @submit.prevent="">
                <div class="row">
                    <BaseSelect
                        class="col-12 mb-3"
                        id="type"
                        :items="trackerTypes"
                        label="Tipo *"
                        :required="false"
                        v-model="tracker.type"
                    />
                    <BaseSelect
                        v-if="tracker.type == 'pixel'"
                        class="col-12 mb-3"
                        id="tracking_type"
                        :items="pixelType"
                        label="Tipo de rastreio"
                        :required="false"
                        v-model="tracker.content.tracking_type"
                    />
                    <BaseInput
                        class="col-12 mb-3"
                        label="Descrição *"
                        id="title"
                        :required="false"
                        v-model="tracker.title"
                        :page="route.name"
                    />
                    <BaseInput
                        class="col-12 mb-3"
                        label="ID *"
                        id="content.code"
                        :required="false"
                        v-model="tracker.content.code"
                        :page="route.name"
                    />
                    <div v-if="tracker.type == 'pixel' && tracker.content.tracking_type == 'api'">
                        <BaseInput
                            class="col-12 mb-3"
                            label="Token de acesso"
                            id="accesstoken"
                            :required="false"
                            v-model="tracker.content.access_token"
                            :page="route.name"
                        />
                        <BaseInput
                            class="col-12 mb-3"
                            label="Código de teste"
                            id="testoken"
                            :required="false"
                            v-model="tracker.content.test_code"
                            :page="route.name"
                        />
                    </div>
                    <BaseInput 
                        v-if="tracker.type == 'google_ads'"
                        class="col-12 mb-3"
                        id="content.label"
                        label="Rótulo de conversão"
                        :required="false"
                        v-model="tracker.content.label"
                    />
                    <BaseInput 
                        v-if="tracker.type == 'pixel' && tracker.tracking_type == 'code'"
                        class="col-12 mb-3"
                        id="content.domain"
                        label="Domínio"
                        placeholder="pixel.seudominio.com.br"
                        :required="false"
                        v-model="tracker.content.domain"
                    />
                    <BaseSelect
                        class="col-12 mb-3"
                        id="content.track_in"
                        :items="trackerActions"
                        label="Executar em *"
                        :required="false"
                        v-model="tracker.content.track_in"
                        :page="route.name" 
                    />
                    <div v-if="tracker.type == 'google_ads' || tracker.type == 'outbrain'">
                        <label>Executar conversão nas formas de pagamento</label>
                        <BaseSwitch
                            v-model:checked="tracker.content.track_boleto"  
                            label="Boleto gerado"
                            id="boleto"
                            :page="route.name" 
                        />
                        <BaseSwitch
                            v-model:checked="tracker.content.track_pix" 
                            label="Pix gerado"
                            id="pix"
                            :page="route.name" 
                        />
                        <BaseSwitch
                            v-model:checked="tracker.content.track_credit_card"
                            label="Cartão de crédito"
                            id="credit_card"
                            :page="route.name"
                        />
                    </div>
                    <div v-if="tracker.type == 'pixel' && tracker.content.tracking_type">
                        <label>Executar conversão nas formas de pagamento</label>
                        <BaseSwitch
                            v-model:checked="tracker.content.track_boleto"  
                            label="Boleto gerado"
                            id="boleto"
                            class="mb-3"
                            :page="route.name" 
                        />
                        <BaseSwitch
                            v-if="tracker.content.tracking_type == 'api'"
                            v-model:checked="tracker.content.track_boleto_paid"  
                            label="Boleto pago"
                            id="boletopaid"
                            class="mb-3"                            
                            :page="route.name" 
                        />
                        <BaseSwitch
                            v-model:checked="tracker.content.track_pix" 
                            label="Pix gerado"
                            id="pix"
                            class="mb-3"
                            :page="route.name" 
                        />
                        <BaseSwitch
                            v-model:checked="tracker.content.track_pix_paid" 
                            label="Pix pago"
                            id="pixpaid"
                            class="mb-3"
                            :page="route.name" 
                        />
                        <BaseSwitch
                            v-model:checked="tracker.content.track_credit_card"
                            label="Cartão de crédito"
                            id="credit_card"
                            class="mb-3"
                            :page="route.name"
                        />
                    </div>
                </div>
                <BaseButton @click="submit" class="mt-4 btn-success w-100">
                    Salvar
                </BaseButton>
            </form>
        </BasePopup>
    </div>
</template>

<script setup>
import { ref, onBeforeMount, computed } from 'vue'
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router'
import { useGlobalStore } from '@/stores/global';
import { useCampaignStore } from '@/stores/campaign';

const route = useRoute();
const router = useRouter();

let previousPage = router.options.history.state.back;
const campaign_id = computed (function () {
    return route.params.id;
});

const campaignStore = useCampaignStore();
const { tracker } = storeToRefs(campaignStore);

const globalStore = useGlobalStore();

function clickToClose() {
    router.push(previousPage)
}
const trackerTypes = ref({
    'google_analytics': 'Google Analytics',
    'google_tag_manager': 'Google Tag Manager',
    'google_ads': 'Google ADS',
    'pixel': 'Facebook Pixel',
    'taboola': 'Taboola',
    'outbrain': 'Outbrain',
    'tiktok': 'TikTok',
    'microsoft_clarity': 'Microsoft Clarity',

})

const trackerActions = ref({
   'all': 'Todas as páginas',
   'checkout': 'Somente na página de checkout',
   'order': 'Somente na página de obrigado',
})

const pixelType = ref({
    'api' : 'API',
    'code' : 'Código',
})


onBeforeMount(() => {
    delete globalStore.errors[route.name];

    if(route.name == 'campaignTrackerCreate'){
        globalStore.cleanObject(campaignStore.tracker);
    }
});

async function submit() {
    globalStore.loader('show')

    if(route.name == 'campaignTrackerEdit'){

        let params = ['type', 'content', 'title'];

        globalStore.loader('show');
        campaignStore.tryUpdateTracker(params, route.name).then(function(success) {
            globalStore.loader('hide');

            if(success){
                campaignStore.tryTrackers(campaign_id.value);
                router.push('/campaigns/' + campaign_id.value + '/trackers')
            }
        })
    }
    else if(route.name == 'campaignTrackerCreate'){
        let params = ['type', 'content', 'title'];

        globalStore.loader('show');
        campaignStore.tryCreateTracker(campaign_id.value, params, route.name).then(function(success) {
            globalStore.loader('hide');

            if(success){
                campaignStore.tryTrackers(campaign_id.value);
                router.push('/campaigns/' + campaign_id.value + '/trackers')
            }
        })
    }
}   


</script>

<style scoped>

header{
    width: 100%;
    display: block!important;
    margin: 0;
    padding-top: 6px;
    font-size: 16px;
    color: #646464;
    font-weight: 600;
}

</style>